import { OpaqueToken } from '@angular/core';

import { EN_NAME, EN_TRANS } from './lang_en';
import { ES_NAME, ES_TRANS } from './lang_es';

const dictionary = {};
dictionary[EN_NAME] = EN_TRANS;
dictionary[ES_NAME] = ES_TRANS;
export const TRANSLATIONS = new OpaqueToken('translations');

export const TRANSLATION_PROVIDERS = [
  { provide: TRANSLATIONS, useValue: dictionary }
];



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/i18n/translations.ts